/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.utils

object StringUtils {

  def asOption(str: String): Option[String] =
    if (str == null || str.isEmpty) None else Some(str)

}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/utils/StringUtils.scala